import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import type { ComponentProps } from "react";
import { Link } from "react-router-dom";

import { AuthImage } from "./AuthImage";
import type { ManualDoc } from "./types";

export function MarkdownView({ doc }: { doc: ManualDoc }) {
  // 表示 children が装飾を含んでも、AST の位置からサーバーの見出しを引ける。
  const headings = new Map(doc.sections.map((s) => [s.title, s.anchor]));
  const lines = doc.markdown.split("\n");
  type HeadingProps = ComponentProps<"h2"> & { node?: { position?: { start: { line: number } } } };
  const headingId = (node: HeadingProps["node"]) => node?.position
    ? headings.get(lines[node.position.start.line - 1]?.replace(/^#{2,3} /, "")) : undefined;
  return (
    <article className="manual-markdown">
      <ReactMarkdown remarkPlugins={[remarkGfm]} skipHtml components={{
        h1: ({ children }: HeadingProps) => <h2>{children}</h2>,
        h2: ({ children, node }: HeadingProps) => <h2 id={headingId(node)}>{children}</h2>,
        h3: ({ children, node }: HeadingProps) => <h3 id={headingId(node)}>{children}</h3>,
        img: ({ src, alt }: ComponentProps<"img">) => <AuthImage src={typeof src === "string" ? src : undefined}
          alt={alt} module={doc.module} view={doc.view} />,
        a: ({ href, children }: ComponentProps<"a">) => href && (href.startsWith("#") ||
          /^\/manual\/(common|hr|mdm|idp|dlp|admin|reception)(?:#[^\s]*)?$/.test(href))
          ? <Link to={href}>{children}</Link> : <>{children}</>,
      }}>{doc.markdown}</ReactMarkdown>
    </article>
  );
}
